import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getHomeApi, getProfilePage } from "../../api/Api";
import RouteContents from "../../constants/routesContent.json";

export const HomePageContext = createContext({});
export const HomePageContextProvider = ({ children }) => {
  const [homeData, setHomeData] = useState([]);
  const [profileData, setProfileData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);
  const [showSpinner ,setShowSpinner] = useState(false)
  const navigate = useNavigate();
  useEffect(() => {
    // window.addEventListener("popstate", (e) => {
    //   window.history.go(1);
    //   e.preventDefault();
    // });
    localStorage.setItem("previousPath", window.location.pathname);
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }, []);

  const profileDetail = async () => {
    setShowAlert(false);
    try {
      const response = await getProfilePage();
      if (response?.data?.status === 200) {
        setShowAlert(false);
        setProfileData(response?.data?.data?.admin);
      }
    } catch (error) {
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        const errorMessage = error.response.data.message;

        setShowAlert(true);
        setAlertMessage(errorMessage);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const homeDataApi = async () => { 
    setShowSpinner(true)
    setShowAlert(false);
    try {
      const getData = await getHomeApi();
      if (getData?.data?.status === 200) {
        setShowAlert(false);
        setHomeData(getData?.data?.data?.logs);
        setShowSpinner(false)
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      setShowSpinner(false)
      if (error?.response?.data?.status === 400) {
        const errorMessage = error?.response?.data?.message;
        setShowAlert(true);
        setAlertMessage(errorMessage);
        setShowSpinner(false)
      } else if (error?.response?.data?.status === 401) {
        const errorMessage = error?.response?.data?.message;
        setShowAlert(true);
        setAlertMessage(errorMessage);
        setShowSpinner(false)
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
        setShowSpinner(false)
      }
    }
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContents.LOGIN);
  };

  const providerValue = {
    homeDataApi,
    homeData,
    profileData,
    profileDetail,
    showAlert,
    setShowAlert,
    statusCode,
    logout,
    alertMessage,
    setAlertMessage,
    showSpinner ,setShowSpinner
  };

  return (
    <HomePageContext.Provider value={providerValue}>
      {children}
    </HomePageContext.Provider>
  );
};
